<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/shop-news">ショップニュース一覧</router-link></li>
          <li v-if="shopNewsDetail.acf?.title != ''"><router-link :to="'/shop-news/' + shopNewsDetail.id">{{shopNewsDetail.acf?.title}}</router-link></li>
          <li v-else><router-link :to="'/shop-news/' + shopNewsDetail.id">{{shopNewsDetail.acf?.explanation}}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="shopnew-detail">
      <div class="shopnew-detail__cont">
        <div class="container">
          <div class="shopnew-detail__holder">
            <h2 class="page--title" v-if="!isLoading">SHOP NEWS<span>ショップニュース</span></h2>
            <div class="skeleton-parent" v-if="isLoading">
              <PuSkeleton style="height: 60px;" :count="1"/>
            </div>
            <div class="cont-top">
              <div class="text-top" v-if="shopNewsDetail.acf?.start_date && !isLoading">公開日：<span>{{ formatDate(shopNewsDetail.acf?.start_date) }}</span>({{ formatWeekDay(shopNewsDetail.acf?.start_date) }})</div>
              <div class="skeleton-parent" v-if="isLoading">
                <PuSkeleton style="height: 15px;" :count="1"/>
              </div>
              <h2 v-if="shopNewsDetail.acf?.title && !isLoading">{{ shopNewsDetail.acf?.title }}</h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin: 10px 0;">
                <PuSkeleton style="height: 25px;" :count="1"/>
              </div>
              <ul class="list-tag" v-if="shopNewsDetail.acf?.category && !isLoading">
                <li v-if="shopNewsDetail.acf?.category">{{ shopNewsDetail.acf?.category }}</li>
              </ul>
              <div class="skeleton-parent" v-if="isLoading" style="margin: 15px 0;">
                <PuSkeleton style="height: 25px;" :count="1"/>
              </div>
              <div class="shopnewsdetail__img__list">
                <div v-if="shopNewsDetail.acf?.news_image1 && !isLoading && shopNewsDetail.acf?.news_image1 != '' && shopNewsDetail.acf?.news_image1 != false" class="cont-featureimg" 
                :class="
                  (shopNewsDetail.acf?.file1 &&
                  shopNewsDetail.acf?.file_name1) ||
                  (shopNewsDetail.acf?.file2 &&
                  shopNewsDetail.acf?.file_name2) ||
                  (shopNewsDetail.acf?.file3 &&
                  shopNewsDetail.acf?.file_name3) ||
                  (shopNewsDetail.acf?.file4 &&
                  shopNewsDetail.acf?.file_name4) ||
                  (shopNewsDetail.acf?.file5 &&
                  shopNewsDetail.acf?.file_name5) ||
                  shopGuideDetail.shop_type ||
                  shopGuideDetail.shop_logo_image ||
                  shopGuideDetail.shop_name ||
                  shopGuideDetail.shop_id ||
                  shopNewsDetail.acf?.explanation ? '' : 'img-custom'" :style="{backgroundImage: `url(${$func.formatUrl(shopNewsDetail.acf?.news_image1)})`}">
                  <img
                      :src="$func.formatUrl(shopNewsDetail.acf?.news_image1)"
                      alt="event feature img"
                  />
                </div>
                <div v-if="shopNewsDetail.acf?.news_image1 === '' || shopNewsDetail.acf?.news_image1 === false" class="cont-featureimg" 
                :class="
                  (shopNewsDetail.acf?.file1 &&
                  shopNewsDetail.acf?.file_name1) ||
                  (shopNewsDetail.acf?.file2 &&
                  shopNewsDetail.acf?.file_name2) ||
                  (shopNewsDetail.acf?.file3 &&
                  shopNewsDetail.acf?.file_name3) ||
                  (shopNewsDetail.acf?.file4 &&
                  shopNewsDetail.acf?.file_name4) ||
                  (shopNewsDetail.acf?.file5 &&
                  shopNewsDetail.acf?.file_name5) ||
                  shopGuideDetail.shop_type ||
                  shopGuideDetail.shop_logo_image ||
                  shopGuideDetail.shop_name ||
                  shopGuideDetail.shop_id ||
                  shopNewsDetail.acf?.explanation ? '' : 'img-custom'" :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }">
                  <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
                </div>
                <div v-if="shopNewsDetail.acf?.news_image2 && !isLoading" class="cont-featureimg" 
                :class="
                  (shopNewsDetail.acf?.file1 &&
                  shopNewsDetail.acf?.file_name1) ||
                  (shopNewsDetail.acf?.file2 &&
                  shopNewsDetail.acf?.file_name2) ||
                  (shopNewsDetail.acf?.file3 &&
                  shopNewsDetail.acf?.file_name3) ||
                  (shopNewsDetail.acf?.file4 &&
                  shopNewsDetail.acf?.file_name4) ||
                  (shopNewsDetail.acf?.file5 &&
                  shopNewsDetail.acf?.file_name5) ||
                  shopGuideDetail.shop_type ||
                  shopGuideDetail.shop_logo_image ||
                  shopGuideDetail.shop_name ||
                  shopGuideDetail.shop_id ||
                  shopNewsDetail.acf?.explanation ? '' : 'img-custom'" :style="{backgroundImage: `url(${$func.formatUrl(shopNewsDetail.acf?.news_image2)})`}">
                  <img
                      :src="$func.formatUrl(shopNewsDetail.acf?.news_image2)"
                      alt="event feature img2"
                  />
                </div>
                <div v-if="shopNewsDetail.acf?.news_image3 && !isLoading" class="cont-featureimg" 
                :class="
                  (shopNewsDetail.acf?.file1 &&
                  shopNewsDetail.acf?.file_name1) ||
                  (shopNewsDetail.acf?.file2 &&
                  shopNewsDetail.acf?.file_name2) ||
                  (shopNewsDetail.acf?.file3 &&
                  shopNewsDetail.acf?.file_name3) ||
                  (shopNewsDetail.acf?.file4 &&
                  shopNewsDetail.acf?.file_name4) ||
                  (shopNewsDetail.acf?.file5 &&
                  shopNewsDetail.acf?.file_name5) ||
                  shopGuideDetail.shop_type ||
                  shopGuideDetail.shop_logo_image ||
                  shopGuideDetail.shop_name ||
                  shopGuideDetail.shop_id ||
                  shopNewsDetail.acf?.explanation ? '' : 'img-custom'" :style="{backgroundImage: `url(${$func.formatUrl(shopNewsDetail.acf?.news_image3)})`}">
                  <img
                      :src="$func.formatUrl(shopNewsDetail.acf?.news_image3)"
                      alt="event feature img3"
                  />
                </div>
                <div v-if="shopNewsDetail.acf?.news_image4 && !isLoading" class="cont-featureimg" 
                :class="
                  (shopNewsDetail.acf?.file1 &&
                  shopNewsDetail.acf?.file_name1) ||
                  (shopNewsDetail.acf?.file2 &&
                  shopNewsDetail.acf?.file_name2) ||
                  (shopNewsDetail.acf?.file3 &&
                  shopNewsDetail.acf?.file_name3) ||
                  (shopNewsDetail.acf?.file4 &&
                  shopNewsDetail.acf?.file_name4) ||
                  (shopNewsDetail.acf?.file5 &&
                  shopNewsDetail.acf?.file_name5) ||
                  shopGuideDetail.shop_type ||
                  shopGuideDetail.shop_logo_image ||
                  shopGuideDetail.shop_name ||
                  shopGuideDetail.shop_id ||
                  shopNewsDetail.acf?.explanation ? '' : 'img-custom'" :style="{backgroundImage: `url(${$func.formatUrl(shopNewsDetail.acf?.news_image4)})`}">
                  <img
                      :src="$func.formatUrl(shopNewsDetail.acf?.news_image4)"
                      alt="event feature img4"
                  />
                </div>
              </div>
              <div class="skeleton-parent" v-if="isLoading">
                <PuSkeleton style="height: 500px;" :count="1"/>
              </div>
              <div v-if="shopGuideDetail.shop_type ||
                  shopGuideDetail.shop_logo_image ||
                  shopGuideDetail.shop_name ||
                  shopGuideDetail.shop_id ||
                  shopNewsDetail.acf?.explanation" 
                  class="custom-content mb-custom" :class="(shopNewsDetail.acf?.file1 &&
                  shopNewsDetail.acf?.file_name1) ||
                  (shopNewsDetail.acf?.file2 &&
                  shopNewsDetail.acf?.file_name2) ||
                  (shopNewsDetail.acf?.file3 &&
                  shopNewsDetail.acf?.file_name3) ||
                  (shopNewsDetail.acf?.file4 &&
                  shopNewsDetail.acf?.file_name4) ||
                  (shopNewsDetail.acf?.file5 &&
                  shopNewsDetail.acf?.file_name5) ? '' : 'custom-content-style'">
                <ul class="list-tag" v-if="shopGuideDetail.shop_type && !isLoading">
                  <li :class="shopGuideDetail.shop_type === '飲食' ? '' : 'tag--grey'" v-if="shopGuideDetail.shop_type === '飲食' && shopGuideDetail.shop_type != null && shopGuideDetail.shop_type != ''">{{ shopGuideDetail.shop_type }}</li>
                  <li :class="shopGuideDetail.shop_type === 'その他' ? 'tag--grey' : ''" v-if="shopGuideDetail.shop_type === 'その他' && shopGuideDetail.shop_type != null && shopGuideDetail.shop_type != ''">{{ shopGuideDetail.shop_type }}</li>
                </ul>
                <div class="skeleton-parent" v-if="isLoading" style="margin: 15px 0;">
                  <PuSkeleton style="height: 25px;" :count="1"/>
                </div>
                <div class="cont-shopdecs" v-if="!isLoading">
                  <div class="cont-shopdecs__logo" v-if="shopGuideDetail.shop_logo_image">
                    <img
                      :src="$func.formatUrl(shopGuideDetail.shop_logo_image)"
                      alt="shopnew logo"
                    />
                  </div>
                  <div class="cont-shopdecs__name" v-if="shopGuideDetail.shop_name || shopGuideDetail.shop_id">{{ shopGuideDetail.shop_id + '.' + shopGuideDetail.shop_name }}</div>
                </div>
                <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 30px;">
                  <PuSkeleton style="height: 100px;" :count="1"/>
                </div>
                <div class="cont-text" v-if="shopNewsDetail.acf?.explanation && !isLoading">
                  <p v-html="shopNewsDetail.acf?.explanation"></p>
                </div>
                <div class="skeleton-parent" v-if="isLoading">
                  <PuSkeleton :count="5"/>
                </div>
              </div>
              <!-- <div class="cont-silink">
                <ul class="silink__list">
                  <li class="silink__list__item">
                    <a 
                      target="_blank"
                      :href="`https://social-plugins.line.me/lineit/share?url=${shopNewslUrl}`"
                      ><img src="@/assets/img/common/si_line.svg" alt="line"
                    /></a>
                  </li>
                  <li class="silink__list__item">
                    <a 
                      target="_blank"
                      :href="`https://twitter.com/intent/tweet?text=${shopNewslUrl}`"
                      ><img
                        src="@/assets/img/common/si_twitter.svg"
                        alt="twitter"
                    /></a>
                  </li>
                  <li class="silink__list__item">
                    <a 
                      target="_blank" 
                      :href="`https://www.facebook.com/sharer/sharer.php?u=${shopNewslUrl}`"
                      ><img
                        src="@/assets/img/common/si_facebook.svg"
                        alt="facebook"
                    /></a>
                  </li>
                  <li class="silink__list__item">
                    <a 
                      :href="`mailto:?body=${shopNewslUrl}`"
                      aria-current="page" 
                      class="router-link-exact-active router-link-active">
                      <img src="@/assets/img/common/si_mail.svg" alt="mail">
                    </a>
                  </li>
                </ul>
              </div> -->
              <div class="cont-leaflets" v-if="
                  (shopNewsDetail.acf?.file1 &&
                  shopNewsDetail.acf?.file_name1) ||
                  (shopNewsDetail.acf?.file2 &&
                  shopNewsDetail.acf?.file_name2) ||
                  (shopNewsDetail.acf?.file3 &&
                  shopNewsDetail.acf?.file_name3) ||
                  (shopNewsDetail.acf?.file4 &&
                  shopNewsDetail.acf?.file_name4) ||
                  (shopNewsDetail.acf?.file5 &&
                  shopNewsDetail.acf?.file_name5) && !isLoading">
                <h3>ショップチラシ</h3>
                <ul>
                  <li v-if="shopNewsDetail.acf?.file1 && shopNewsDetail.acf?.file_name1">
                    <a target="_blank" :href="$func.formatUrl(shopNewsDetail.acf?.file1)">{{ shopNewsDetail.acf?.file_name1 }}</a>
                  </li>
                  <li v-if="shopNewsDetail.acf?.file2 && shopNewsDetail.acf?.file_name2">
                    <a target="_blank" :href="$func.formatUrl(shopNewsDetail.acf?.file2)">{{ shopNewsDetail.acf?.file_name2 }}</a>
                  </li>
                  <li v-if="shopNewsDetail.acf?.file3 && shopNewsDetail.acf?.file_name3">
                    <a target="_blank" :href="$func.formatUrl(shopNewsDetail.acf?.file3)">{{ shopNewsDetail.acf?.file_name3 }}</a>
                  </li>
                  <li v-if="shopNewsDetail.acf?.file4 && shopNewsDetail.acf?.file_name4">
                    <a target="_blank" :href="$func.formatUrl(shopNewsDetail.acf?.file4)">{{ shopNewsDetail.acf?.file_name4 }}</a>
                  </li>
                  <li v-if="shopNewsDetail.acf?.file5 && shopNewsDetail.acf?.file_name5">
                    <a target="_blank" :href="$func.formatUrl(shopNewsDetail.acf?.file5)">{{ shopNewsDetail.acf?.file_name5 }}</a>
                  </li>
                </ul>
              </div>
              <div class="skeleton-parent" v-if="isLoading">
                <PuSkeleton style="height: 100px;" :count="1"/>
              </div>
            </div>
          </div>
        </div>
        <div class="cont-bottom">
          <div class="container">
            <div class="shopnew-detail__holder">
              <div class="shopinfo">
                <h2 class="page--title">SHOP INFO<span>ショップ情報</span></h2>
                <div class="shopinfo__detail">
                  <div class="shopinfo__detail__content">
                    <div class="content__address" v-if="shopGuideDetail.shop_area || shopGuideDetail.shop_floor && !isLoading">{{ shopGuideDetail.shop_area + shopGuideDetail.shop_floor }}</div>
                    <div class="skeleton-parent" v-if="isLoading" style="margin: 10px 0;">
                        <PuSkeleton style="height: 20px;" :count="1"/>
                    </div>
                    <div class="content__hour" v-if="shopGuideDetail.shop_hours && !isLoading">
                      <p v-if="shopGuideDetail.shop_hours">営業時間：</p>
                      <p v-if="shopGuideDetail.shop_hours" class="shop__hours">{{ shopGuideDetail.shop_hours }}</p>
                    </div>
                    <div class="skeleton-parent" v-if="isLoading" style="margin: 10px 0;">
                        <PuSkeleton style="height: 20px;" :count="1"/>
                    </div>
                    <div class="content__tel" v-if="shopGuideDetail.shop_tel && !isLoading">
                      <p>
                        TEL：<a :href="'tel:' + shopGuideDetail.shop_tel"
                          ><span>{{ shopGuideDetail.shop_tel }}</span></a>
                      </p>
                    </div>
                    <div class="skeleton-parent" v-if="isLoading" style="margin: 10px 0;">
                        <PuSkeleton style="height: 20px;" :count="1"/>
                    </div>
                  </div>
                  <div v-if="shopGuideDetail.site_url || shopGuideDetail.link_url" class="shopinfo__detail__link">
                    <ul v-if="shopGuideDetail.site_url || shopGuideDetail.link_url && !isLoading">
                      <li v-if="shopGuideDetail.site_url && shopGuideDetail.site_url != null && shopGuideDetail.site_url != ''"><a target="_blank" :href="shopGuideDetail.site_url">公式ホームページ</a></li>
                      <li v-if="shopGuideDetail.link_url && shopGuideDetail.link_url != null && shopGuideDetail.link_url!= '' ">
                        <a target="_blank" :href="shopGuideDetail.link_url">{{ shopGuideDetail.link_url }}</a>
                      </li>
                    </ul>
                    <div class="skeleton-parent" v-if="isLoading" style="margin: 5px 0;">
                        <PuSkeleton style="height: 20px;" :count="2"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-list">
                <router-link v-if="shopNewsDetail.acf?.relation_shop_guide" :to="'/shop-guide/' + shopNewsDetail.acf?.relation_shop_guide">ショップガイド(詳細)</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { RouterLink } from "vue-router";
import { sliderSite } from "@/assets/js/home";
import CONSTANT from "../../../constant.js";
import { getUrl, metaData, formatUrlDetail } from '@/utils/helper';
import router from "@/router";

export default {
  name: "ShopNewsDetail",
  components: {
  },
  data() {
    return {
      shopNewsDetail: [],
      isLoading: true,
      urlNowRinting: CONSTANT.dataImageNowrinting,
      dataFilter: CONSTANT.dataFilter[0],
      shopNewslUrl: window.location.href,
      shopGuideDetail: {
        shop_id: '',
        shop_name: '',
        shop_image: '',
        shop_type: '',
        shop_logo_image: '',
        shop_area: '',
        shop_floor: '',
        shop_hours: '',
        shop_tel: '',
        site_url: '',
        link_url: '',
      }
    };
  },
  mounted() {
    // const getImgage = this.$el.querySelector(".cont-featureimg img");
    // this.$el.querySelector(
    //   ".cont-featureimg"
    // ).style.backgroundImage = `url(${getImgage.src})`;
  },
  computed: {},
  methods: {
    formatUrlDetail,
    formatDate(shopNews) {
      return moment(shopNews.replaceAll('/', '-')).format("YYYY/MM/DD");
    },
    formatWeekDay(shopnews) {
      moment.locale('ja');  
      const d = moment(shopnews.replaceAll('/', '-')).format("dd");
      return d;
    },
  },
  created() {
    this.isLoading = true
    getUrl(`/shop_news/${this.$route.params.id}`)
      .then((response) => {
        let deliveryMedia = response.data.acf?.delivery_media; 
        if(deliveryMedia.includes(this.dataFilter.town)) { 
          this.shopNewsDetail = response.data;
        } else { 
          this.$router.push('/notFound' )
        }

        this.shopGuideDetail = {
          shop_id: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_id || '') : (response.data.acf?.shop_number || ''),
          shop_name: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_name || '') : (response.data.acf?.shop_name || ''),
          shop_image: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_image || '') : (response.data.acf?.shop_image || ''),
          shop_type: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_type || '') : (response.data.acf?.shop_type || ''),
          shop_logo_image: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_logo_image || '') : (response.data.acf?.shop_logo_image || ''),
          shop_area: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_area || '') : (response.data.acf?.shop_area || ''),
          shop_floor: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_floor || '') : (response.data.acf?.shop_floor || ''),
          shop_hours: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_hours || '') : (response.data.acf?.shop_hours || ''),
          shop_tel: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.shop_tel || '') : (response.data.acf?.shop_tel || ''),
          site_url: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.site_url || '') : (response.data.acf?.site_url || ''),
          link_url: response.data.acf?.relation_shop_guide ? (response.data.acf?.relation_shop_guide_detail?.acf?.link_url || '') : (response.data.acf?.link_url || ''),
        }

        metaData(
          `${this.shopNewsDetail.acf?.title ? this.shopNewsDetail.acf?.title : ''} | HARUMIFLAGタウンポータル`,
          '',
          'HARUMIFLAGタウンポータル',
          'article',
          `${formatUrlDetail(this.shopNewsDetail.acf?.news_image1)}`
        )

        this.isLoading = false
      })
      .catch((e) => {
        console.log(e);
        this.$router.push('/NotFound')
      });
  },
  updated() {
    sliderSite()
  }
};
</script>
